export interface ZoneActionTypes {
  type: ZoneActions;
  payload?: any;
}

export enum ZoneActions {
  CREATE_ZONE = "CREATE_ZONE",
  GET_ZONE_LIST = "GET_ZONE_LIST",
  SET_ZONE_LIST = "SET_ZONE_LIST",
  SET_ZONE_LIST_PAGE_COUNT = "SET_ZONE_LIST_PAGE_COUNT",
  GET_ZONE_DATA_BY_ID = "GET_ZONE_DATA_BY_ID",
  SET_ZONE_DATA_BY_ID = "SET_ZONE_DATA_BY_ID",
  EDIT_ZONE_DATA_BY_ID = "EDIT_ZONE_DATA_BY_ID",
  DELETE_ZONE = "DELETE_ZONE",
}
